module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.eot?77111476f05dd3443047d910e3d81b5f";